import { Message } from "./chat/ChatComponent";
import { UserIcon, BotIcon } from "./icons";
import { cn } from "@/lib/utils";

interface ReplyToMessageProps {
  message: Message;
  onClose: () => void;
  isReplying: boolean;
}

export function ReplyToMessage({
  message,
  onClose,
  isReplying
}: ReplyToMessageProps) {

    if (!isReplying) {
        return null;
    }

  return (
    <div
      className={cn(
        "flex items-start rounded-md p-3 mb-2 text-sm shadow-md transition-transform transform",
        message.role === "user"
          ? "bg-neutral-100 dark:bg-neutral-700 border-neutral-300 dark:border-neutral-600"
          : "bg-neutral-50 dark:bg-neutral-600 border-neutral-200 dark:border-neutral-500"
      )}
    >
      <div className="mr-2">
        {message.role === "user" ? (
          <UserIcon />
        ) : (
          <BotIcon />
        )}
      </div>
      <div className="flex-1">
        <div className="font-medium text-neutral-800 dark:text-neutral-200">
          {message.role === "user" ? "You" : "Assistant"}
        </div>
        <div className="text-neutral-600 dark:text-neutral-300">
          {message.content.length > 100
            ? `${message.content.substring(0, 100)}...`
            : message.content}
        </div>
      </div>
      <button
        className="ml-2 text-neutral-500 hover:text-neutral-700 dark:hover:text-neutral-200"
        onClick={onClose}
        title="Cancel Reply"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-4 h-4"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  );
} 